import XCheckbox from "./common/XCheckbox";
import DatePickers from "./ui-control/DatePicker";
import XInput from "./common/XInput";
import { Field } from "formik";

const SubscriptionDetails = ({formik}) => {
    return (
        <>
            <h2>
                <div className="flex justify-between items-center w-full! mr-4!">
                    <span>Subscription Details</span>
                </div>
            </h2>
            <div className='row'>
                <div className='col-md-4'>
                    <div className="form-group">
                        <XInput name="monthlyPrice"   label="Monthly Total Subscription Price" {...formik?.getFieldProps("monthlyPrice")} 
                        error={formik.touched.monthlyPrice && formik.errors.monthlyPrice} 
                        />
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className="form-group">
                        <XInput name="demandsPerMonth"   label="Demand Per Month" {...formik?.getFieldProps("demandsPerMonth")} 
                        error={formik.touched.demandsPerMonth && formik.errors.demandsPerMonth}
                        />
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className="form-group">
                        <XInput name="usersLimit" type="number"  label="User Limit" {...formik?.getFieldProps("usersLimit")} 
                        error={formik.touched.usersLimit && formik.errors.usersLimit}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col-md-4'>
                        <div className="form-group">
                            <XInput name="costPerAdditionalUser" type="number"  label="Cost per additional user in $" {...formik?.getFieldProps("costPerAdditionalUser")} 
                            error={formik.touched.costPerAdditionalUser && formik.errors.costPerAdditionalUser}
                            />
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-group">
                            <XInput name="costPerAdditionalDemand" type="number"  label="Cost per additional demand in $" {...formik?.getFieldProps("costPerAdditionalDemand")}
                            error={formik.touched.costPerAdditionalDemand && formik.errors.costPerAdditionalDemand}
                            />
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-group">
                            <XCheckbox
                                name="chargeAdditionalPlaintiffs"
                                label="Charge for additional plaintiffs"
                                checked={!!formik.values.chargeAdditionalPlaintiffs}
                                onChange={formik.handleChange}
                            />
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-group [&_label]:block! [&_label]:font-sans">
                            <Field name="subscriptionRenewalDate"  label="Subscription Date" component={DatePickers} />
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="form-group [&_label]:block! [&_label]:font-sans">
                            <Field name="contractRenewalDate"  label="Contract Renewal Date" component={DatePickers} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubscriptionDetails;